// Thema's (feat/themas), zie themesApp.nl.ts.
export const appThemesEn = {
    audience: 'Theme of this board',
    audienceHint: 'You can change this later in Tablets, or on the board itself with Adjust (also per screen).',
    adult: 'Family and adults',
    adultHint: 'Adults theme: calm and clean, neutral colours and line pictograms.',
    kids: 'Children',
    kidsHint: "Children theme: colourful pictograms, larger buttons and text. If the board is in the children's room, it only shows their things.",
    pictos: 'Pictograms in the app',
    pictosHint: 'Applies on this device.',
    pictosClean: 'Clean (calm lines)',
    pictosColor: 'Playful (colourful)',
};
//# sourceMappingURL=themesApp.en.js.map